var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('O3D',[_c('O3D',{ref:"head",attrs:{"py":35}},[_vm._t("head")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }